<template>
    <MainPage pageTitle="ค้นหาอู่ , ศูนย์ซ่อม , โรงพยาบาลในเครือ" bgClass="bg-a-gray-efefef">
        <div class="flex flex-col flex-auto w-full">
            <div class="flex-none pt-18px px-26px z-10">
                <SearchBarType v-model="model.searchType" />
            </div>
            <div class="flex-auto bg-white rounded-t-22 -mt-10 pt-10">
                <div class="pt-10 px-26">
                    <BaseLocation ref="elemLocation" v-model="model" :isSubmitted="isSubmitted"
                        v-model:valid="locationValid" @init="onLoadProvince()" @ready="onProvinceReady()" />

                    <template v-if="model.searchType == 'G'">
                        <GarageTypeForm v-model:recommended="model.recommended" v-model:truck="model.truck" />
                    </template>
                    <template v-else-if="model.searchType == 'D'">
                        <ServiceForm v-model="model.carBrand" />
                    </template>
                </div>
            </div>
            <div class="flex-none p-6 px-26 bg-white">
                
                <OrangeButton
                    @click="clickSearch()"
                    :customClass="`w-full py-3 rounded-full
                        ${!isCanSearch ? `bg-a-gray-efefef` : `` }`"
                    :disabled="!isCanSearch">
                    ค้นหา
                </OrangeButton>
            </div>
        </div>
    </MainPage>
</template>

<script>
import { computed, defineComponent, inject, ref, watch, onMounted } from 'vue';
import { SearchModel } from '../model/SearchModel';
import { useRouter } from 'vue-router';
import useLoadingModal from "@/helper/composable/modal/useLoadingModal"
import { useTracking } from "@/feature/TrackingFeature"
// component
import MainPage from '@/components/Layout/Page/MainPage.vue';

import SearchBarType from '../component/SearchBarType.vue';
import BaseLocation from '../component/BaseLocation.vue';
import GarageTypeForm from '../component/GarageTypeForm.vue';
import ServiceForm from '../component/ServiceForm.vue';
import OrangeButton from '../../../components/Button/OrangeButton.vue'

export default defineComponent({
    components: {
        MainPage,
        // MainButton,
        SearchBarType,
        BaseLocation,
        GarageTypeForm,
        ServiceForm,
        OrangeButton
    },
    setup: function () {
        const modalStore = inject("ModalStore")
        const { loadingModal } = useLoadingModal(modalStore)
        const model = ref(new SearchModel())
        const isSubmitted = ref(false)
        const locationValid = ref(false)
        const elemLocation = ref(null)
        const router = useRouter()
        /**@type {import('@/helper/TrackingHelper').TrackingService} */
        const tracking = useTracking()

        const isCanSearch = computed(() => {
            // console.log(locationValid.value, isSubmitted.value)
            if (!locationValid.value) {
                return false
            }
            return true
        })

        const clickSearch = function () {
            // console.log(model.value)
            tracking.event("search_page", "click_search", model.value.searchType, "");
            isSubmitted.value = true
            model.value.saveCache()

            router.push({
                name: "dealer_list"
            })
        }

        const onLoadProvince = function () {
            loadingModal.show()
        }

        const onProvinceReady = function () {
            loadingModal.hide()
        }

        watch(() => model.value.searchType, (val) => {
            elemLocation.value.clear()
            model.value.clear(val)
        })

        onMounted(() => {
            tracking.screenName('search')
            tracking.event("search_page", "view_search_page", "", "");
        })

        return {
            model,
            isCanSearch,
            isSubmitted,
            locationValid,
            elemLocation,
            clickSearch,
            onLoadProvince,
            onProvinceReady
        }
    }
})
</script>


